// declare var debug: debug.Debug & { debug: debug.Debug; default: debug.Debug };

const debug = function () {
    var f = new Function();
    f.extend = function () {
        return new Function();
    };
    return f;
};
debug.debug = debug;
debug.default = debug;

module.exports = debug;
